import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import { GET_ALL_PAYMENT_FAILURE, GET_ALL_PAYMENT_REQUEST, GET_ALL_PAYMENT_SUCCESS, VENDOR_TRANSFER_PAYMENT_FAILURE, VENDOR_TRANSFER_PAYMENT_REQUEST, VENDOR_TRANSFER_PAYMENT_SUCCESS } from "./ActionType";


export const getPayments = () => async (dispatch) => {
    dispatch({ type: GET_ALL_PAYMENT_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/payments`);
        dispatch({ type: GET_ALL_PAYMENT_SUCCESS, payload: data })

    } catch (error) {
        dispatch({ type: GET_ALL_PAYMENT_FAILURE, payload: error.message })
    }
}
export const transferPayment = (paymentId) => async (dispatch) => {
    dispatch({ type: VENDOR_TRANSFER_PAYMENT_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/payment/${paymentId}/transfer`);
        dispatch(getPayments())
        dispatch({ type: VENDOR_TRANSFER_PAYMENT_SUCCESS, payload: data })
        toast.success("Vendor Payment Transferred Successfully !!")
    } catch (error) {
        dispatch({ type: VENDOR_TRANSFER_PAYMENT_FAILURE, payload: error.message })
    }
}
